

























import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PrimaryButton from '../../common/buttons/PrimaryButton.vue';
import TertiaryButton from '../../common/buttons/TertiaryButton.vue';
import Plus from '@/assets/img/plus.svg';
import FollowUpAddPopover from './follow_up/FollowUpAddPopover.vue';
import TextButton from '../../common/buttons/TextButton.vue';
const { mapState } = createNamespacedHelpers('grievanceItem');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: { TextButton, FollowUpAddPopover, TertiaryButton, PrimaryButton, Plus },
    computed: {
        ...mapCustomLabelsState(['viewInitialGrievance']),
        ...mapState(['followUps']),
    },
});
